export const ACTION_TITLE_LENGTH_MAX = 100;

export const ISSUE_TITLE_LENGTH_MAX = 100;

export const ISSUE_DESCRIPTION_LENGTH_MAX = 1000;

export const ACTION_DESCRIPTION_LENGTH_MAX = 1000;

export const ISSUE_COMMENT_LENGTH_MAX = 1000;

export const DECLINE_REASON_LENGTH_MAX = 1000;

export const DECLINE_REASON_LENGTH_MIN = 1;

export const DISCARD_MESSAGE_LENGTH_MAX = 1000;

export const SLA_DESCRIPTION_LENGTH_MAX = 100;

export const SUBTYPE_NAME_LENGTH_MAX = 100;
